import React, { useState, useEffect } from 'react';
import { Form, InputGroup, Alert, Container, Button, Table, Tab, Nav, Spinner, Col, Row} from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams} from 'react-router-dom';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import ImageCropper from '../components/Utils/ImageCropper';
import { useProvider, Toast } from '../context/MenuProvider';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

const Calendar = () => {
  const location = useLocation();
  const { metodo } = useParams();
  const queryParams = new URLSearchParams(location.search);
  const pagina = queryParams.get('p')?.toLowerCase();
  const tipo = queryParams.get('t')?.toLowerCase() || 'dia';
  const data = queryParams.get('d')?.toLowerCase();
  const navigate = useNavigate();
  const [isCalendario, setIsCalendario]=useState(true);
  const [query, setQuery]=useState('');
  const [selectModelo, setSelectModelo]=useState('');
  const [nextUrl, setNextUrl] = useState(null);
  const [calendario, setCalendario] = useState([]);
  
  const [currentDate, setCurrentDate] = useState(dayjs(data));
  //const [selectedDay, setSelectedDay] = useState(dayjs(date).date());
  const {
    crud,
    setLinks, 
    setBtns,
  } = useProvider();
  const { get, patch, loading } = crud || {};

  // Lista de compromissos (exemplo)
  const [appointments, setAppointments] = useState([]);
  
  const getChoise = (value) =>{
    switch (value){
      case "visita":
        return "Visita";
      case "evento":
        return "Evento";
      case "apn":
        return "APN";
      case "acompanhamento":
        return "Acompanhamento";
      default:
        return '';
    }
  }
  
  useEffect(() => {
      setLinks([
          // { name: 'Nova Venda', to: '/vendas/novo' },
          // { name: 'Novo Produto', to: '/produtos/novo' },
          // { name: 'Novo Cliente', to: '/clientes/novo' },
          //{ name: 'Configurações', to: '/configuracoes' },
      ]);
      setBtns([
          {icon:isCalendario?'bx-calendar':'bx-calendar-alt', onClick:() => {setIsCalendario(!isCalendario)}},
          //{icon:'bx-search', onClick:() => {setIsPesquisa(!isPesquisa)}},
          //{icon:'bi-pencil-square', to:`/clientes/${id}/editar`},
      ]);
      return () => {setLinks([]); setBtns([]);}
  }, [setLinks, setBtns, appointments, isCalendario])

  const previousMonth = () => {
    const data = currentDate.subtract(1, "month");
    setCurrentDate(data);
    navigate(`?d=${data.toISOString()}&t=mes`, {replace:true});
  };

  const nextMonth = () => {
    const data = currentDate.add(1, "month");
    setCurrentDate(data);
    navigate(`?d=${data.toISOString()}&t=mes`, {replace:true});
  };
  

  const handleDayClick = (day) => {
      const data = currentDate.set("date", day);
      setCurrentDate(data);
      navigate(`?t=dia&d=${data.toISOString()}`, { replace: true });
  };
  
  useEffect(()=>{
    if(query){
      navigate(`?t=query&d=${currentDate.toISOString()}`, { replace: true });
    }else if(tipo==="query"){
      navigate(`?t=dia&d=${currentDate.toISOString()}`, { replace: true });
    }
  },[query])

  const generateCalendar = () => {
    const startOfMonth = currentDate.startOf("month");
    const endOfMonth = currentDate.endOf("month");
    const startDay = startOfMonth.day();
    
    let days = [];
    let day = 1 - startDay;

    for (let row = 0; row < 6; row++) {
      let week = [];
      for (let col = 0; col < 7; col++) {
        if (day > 0 && day <= endOfMonth.date()) {
          week.push(day);
        } else {
          week.push("");
        }
        day++;
      }
      days.push(week);
    }

    return days;
  };

  const hasAppointment = (day) => {
    return calendario.some(
      (item) => dayjs(item.data, "YYYY-MM-DD").date() === day && dayjs(item.data, "YYYY-MM-DD").month() === currentDate.month() && dayjs(item.data, "YYYY-MM-DD").year() === currentDate.year()
    );
  };

  const hasAppointmentStatus = (day, status) => {
    return calendario.some(
      (item) => dayjs(item.data).date() === day && dayjs(item.data).month() === currentDate.month() && dayjs(item.data).year() === currentDate.year() && getStatus(item, status)
    );
  };
  
  const getStatus =(x, status)=>{
    switch(status){
      case "Agendado":
        return x.agendado
      case "Cancelado":
        return x.cancelado
      case "Atrasado":
        return x.atrasado
      case "Realizado":
        return x.realizado
    }
  }
  
  const buscarAgenda = async(novaBusca = false) => {
    try{
      //const primeiroDia = currentDate.date(1).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })
      const primeiroDia = new Date(currentDate.year(), currentDate.month(), 1).toLocaleDateString('sv-SE');
      const ultimoDia = new Date(currentDate.year(), currentDate.month() + 1, 0).toLocaleDateString('sv-SE');
      let url = `/gvendas/agendas/?expand=clientes&filtros=nome_do_cliente,full_name,data,id,observacoes,titulo,status,metodo`;
      
      //alert(tipo)
      switch (tipo) {
        case "mes":
          url += `&ordering=-data&data__date__gte=${primeiroDia}&data__date__lte=${ultimoDia}`;
          break;
        case "dia":
          url += `&ordering=data&data__date__exact=${currentDate.format("YYYY-MM-DD")}`;
          break;
        case "query":
          url += `&search=${query}`;
          break;
      }
      if (metodo) url += `&metodo=${metodo}`;
      if (!metodo && selectModelo) url += `&metodo=${selectModelo}`;

      //alert(url)  
      if (novaBusca) {
          setAppointments([]); // Limpa os produtos anteriores
          setNextUrl(null); // Reseta o nextUrl
      } else if (nextUrl) {
          url = nextUrl; // Se não for nova busca, utiliza o nextUrl
      } else {
          url = null;
      }

      if (!url) return;
      
      const response = await get(url, 'agenda');
      if(response && response.length){
        setNextUrl(response[0].next);
        let novosItens = response[0].results;
        novosItens.forEach((item) => {
          item.date = dayjs(`${item.data}`, "YYYY-MM-DDTHH:mm");

          item.title = `${item.metodo ? getChoise(item.metodo) : ''}${item.metodo && item.titulo ? ' - ' : ''}${item.titulo || ''}`;
        });
        setAppointments((itensAnteriores) => novaBusca ? novosItens : [...itensAnteriores, ...novosItens]);
      }
    }catch(err){
      ////alert(JSON.stringify(err))
    }
  }
  
  const buscarCalendario = async()=>{
    try{
      const parseMes = parseInt(currentDate.month())+1;
      const mes = parseMes<10?`0${parseMes}`:parseMes; //new Date(currentDate.year(), currentDate.month(), 1).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' });
      const ano = currentDate.year();// new Date(currentDate.year(), currentDate.month() + 1, 0).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' });
      let url = `/gvendas/agendas/calendario/${mes}/${ano}/?filtros=id`;
      
      if (metodo) url += `&metodo=${metodo}`;
      if (!metodo && selectModelo) url += `&metodo=${selectModelo}`;
      if (query) url += `&search=${query}`;
      const response = await get(url, 'calendario');
      if(response && response.length){
        //alert(JSON.stringify(response[0].dias))
        setCalendario(response[0].dias);
      }
    }catch(err){
      
    }
  }
  
  useEffect(()=>{
    if(!pagina){
      buscarCalendario();
    }
  },[currentDate?.month(), pagina, selectModelo, metodo])
  
  useEffect(()=>{
    if (!pagina){
      switch(tipo){
        case "dia":
          buscarAgenda(true);
          break;
        case "mes":
          buscarAgenda(true);
          break;
        case "query":
          buscarAgenda(true);
          break;
      }
    }
  },[tipo, currentDate?.date(), query, currentDate?.month()])
  
  useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarAgenda();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
  }, [loading, nextUrl]);
    
  

  const getCor =(item)=>{
    switch (item.status){
      case 'Atrasado':
        return "red";
      case 'Cancelado':
        return "grey";
      case 'Realizado':
        return "green";
      case 'Agendado':
        return "lightgreen";
    }
  }
  
  const updateStatus = async (x, is_realizado, is_cancelado) => {
    try {
      const url = `/gvendas/agendas/${x.id}/?expand=clientes&filtros=nome_do_cliente,full_name,data,id,observacoes,titulo,status,metodo`;
      const response = await patch({
        is_realizado: is_realizado,
        is_cancelado: is_cancelado,
      }, url);
  
      if (response && response.length) {
        setAppointments((prev) =>
          prev.map((item) =>
            item.id === x.id
              ? {
                  ...item,
                  status: response[0].status,
                  is_realizado: response[0].is_realizado,
                  is_cancelado: response[0].is_cancelado,
                }
              : item
          )
        );
        buscarCalendario();
      }
    } catch (err) {
      console.error("Erro ao atualizar status:", err);
    }
  };
  
  const isHoje = (day) =>{
    return currentDate.format("YYYY-MM") === dayjs().format("YYYY-MM") && day === dayjs().date();
  }
  
  const renderizar = (x) => {
    return (<>
      <div
        className={`list-group-item list-group-item-action mb-1`}
        key={x.id} // Adição de key para cada produto
        //to={`?p=detalhes&i=${x.id}`}
        style={{ borderLeft: `5px solid ${getCor(x)}`}}
      >
        <div className="small">
          <span className="text-muted">{x.title}</span>
        </div>
        <Row>
            <Col className="fs-4" onClick={()=>navigate(`?p=detalhes&i=${x.id}`)}>
              {`${x.date.format("DD/MM")} às ${x.date.format("HH:mm")}`}
            </Col>
            {(x.status === 'Agendado' || x.status === "Atrasado") && (<>
              <Col xs="auto" className="small text-muted">
                <Button variant="outline-success" onClick={()=>updateStatus(x,true,false)} className="btn-sm">Concluir</Button>
                <Button variant="outline-danger" onClick={()=>updateStatus(x,false,true)} className="ms-1 btn-sm">Cancelar</Button>
              </Col>
            </>)}
        </Row>
        <div className="text-muted small">
          {x.clientes?.length>0 && (<>
              <Col xs={12} className="mt-2 py-1 border-top">
                {x.clientes.map((x, index) => (
                  <Row>
                    <Col>{x.full_name || x.nome_do_cliente}</Col>
                  </Row>
                ))}
              </Col>
          </>)}
          {x.leads?.length>0 && (<Col xs={12}>{`${x.leads.length} lead${x.leads.length>1?'s':''}`}</Col>)}
          {x.checkins?.length>0 && (<Col xs={12}>{`, ${x.checkins.length} presença${x.checkins.length>1?'s':''}`}</Col>)}
          {x.observacoes && (<Col xs={12} className="mt-2 py-1 border-top">{x.observacoes}</Col>)}
        </div>
      </div>
    </>)
  }
  

  return (
    <>
      {pagina === "nova-agenda" && <NovaAgenda  data={currentDate} queryParams={queryParams} />}
      {pagina === "detalhes" && <NovaAgenda  data={currentDate} queryParams={queryParams}  setAppointments={setAppointments}/>}
      {!pagina && (
        <>
          <BotaoFlutuante onClick={()=>navigate(`?p=nova-agenda`)} icon="bi-plus" posicao={1}></BotaoFlutuante>

            <>
              <Form.Group controlId="formDataSelect" className="my-2">
                <InputGroup>
                  {!metodo && (
                    <Col xs="auto">
                      <Form.Control 
                        className="input-group-text"
                        as="select" 
                        value={selectModelo} 
                        onChange={(e) => setSelectModelo(e.target.value)}
                      >
                        <option value="">Agenda</option>
                        <option value="visita">Visita</option>
                        <option value="acompanhamento">Acompanha</option>
                      </Form.Control>
                    </Col>
                  )}
                  <Form.Control 
                    type="text" 
                    placeholder="Digite sua pesquisa"
                    value={query} 
                    onChange={(e) => setQuery(e.target.value)}
                  />
                  <span className="input-group-text"><i className="bx bx-search"></i></span>
                </InputGroup>
              </Form.Group>
            </>
          <div className="d-flex justify-content-between align-items-center mb-3">
                <Button variant="secondary" onClick={previousMonth}>←</Button>
                <h4 onClick={() => setIsCalendario(!isCalendario)}>{currentDate.format("MMMM YYYY")}</h4>
                <Button variant="secondary" onClick={nextMonth}>→</Button>
          </div>
          <>
              <Form.Group controlId="formData" className="my-2">
                <InputGroup>
                  {!isCalendario && (
                    <>
                      <span className="input-group-text">Data</span>
                      <Form.Control 
                        type="date" 
                        value={currentDate.toISOString().split('T')[0]} 
                        onChange={(e) => setCurrentDate(e.target.value?dayjs(e.target.value):dayjs())}
                      />
                    </>
                  )}
                </InputGroup>
              </Form.Group>
            </>
          {isCalendario && (
            <>
              <Table bordered>
                <thead className="table-dark">
                  <tr>
                    {["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"].map((day) => (
                      <th key={day} className="text-center">{day}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {generateCalendar().map((week, index) => (
                    <tr key={index}>
                      {week.map((day, idx) => (
                        <td
                          key={idx}
                          className={`text-center position-relative ${day === currentDate.date() ? `table-secondary` : isHoje(day)?"table-dark":""}`}
                          onClick={() => day && handleDayClick(day)}
                          style={{ cursor: day ? "pointer" : "default", height: "50px", position: "relative" }}
                        >
                          {day}
                          {day && hasAppointment(day) && (
                            <div
                                style={{
                                  position: "absolute",
                                  top: "5px",
                                  right: "5px",
                                }}
                            >
                              {hasAppointmentStatus(day,'Agendado') && (
                                <div
                                  style={{
                                    width: "8px",
                                    height: "8px",
                                    backgroundColor: "lightgreen",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                              )}
                              {hasAppointmentStatus(day,'Realizado') && (
                                <div
                                  style={{
                                    width: "8px",
                                    height: "8px",
                                    backgroundColor: "green",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                              )}
                              {hasAppointmentStatus(day,'Atrasado') && (
                                <div
                                  style={{
                                    width: "8px",
                                    height: "8px",
                                    backgroundColor: "red",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                              )}
                              {hasAppointmentStatus(day,'Cancelado') && (
                                <div
                                  style={{
                                    width: "8px",
                                    height: "8px",
                                    backgroundColor: "grey",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                              )}
                            </div>
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
          

          <Tab.Container id="details-tabs" activeKey={tipo} onSelect={(k) => navigate(`?t=${k}&d=${currentDate.toISOString()}`, {replace:true})}>
            <Nav variant="tabs" className="justify-content-center">
              {query && (
                <Nav.Item>
                  <Nav.Link eventKey="query"><i className="bx bx-search"></i></Nav.Link>
                </Nav.Item>
              )}
              <Nav.Item>
                <Nav.Link eventKey="dia">{currentDate.date()} de {currentDate.format("MMMM YYYY")}</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="mes">{currentDate.format("MMMM YYYY")}</Nav.Link>
              </Nav.Item>
            </Nav>
    
            <Tab.Content className="">
              {/* Painel de Login */}
              {tipo === 'dia' && (<>
                <div className="list-group mt-3">
                  {appointments
                    .filter((appointment) => appointment.date.month() === currentDate.month() && appointment.date.date() === currentDate.date())
                    .map((x, index) => (
                      renderizar(x)
                    ))}
                  {!appointments
                    .filter((appointment) => appointment.date.month() === currentDate.month() && appointment.date.date() === currentDate.date()).length && (
                      <>
                        {!loading && <p className="text-center text-muted">Nenhuma agenda encontrada.</p>}
                      </>
                    )
                  }
                  {loading && <p className="text-center"><Spinner animation="border" /></p>}
                </div>
              </>)}
              {tipo === 'mes' && (<>
                <div className="list-group mt-3">
                  {appointments
                    .filter((appointment) => appointment.date.month() === currentDate.month())
                    .map((x, index) => (
                        renderizar(x)
                    ))}
                  {!appointments
                    .filter((appointment) => appointment.date.month() === currentDate.month()).length && (
                      <>
                        {!loading && <p className="text-center text-muted">Nenhuma agenda encontrada.</p>}
                      </>
                    )
                  }
                  {loading && <p className="text-center"><Spinner animation="border" /></p>}
                </div>
              </>)}
              {tipo === "query" && (<>
                <div className="list-group mt-3">
                  {appointments
                    .map((x, index) => (
                        renderizar(x)
                    ))}
                  {!appointments
                    .length && (
                      <>
                        {!loading && <p className="text-center text-muted">Nenhuma agenda encontrada.</p>}
                      </>
                    )
                  }
                  {loading && <p className="text-center"><Spinner animation="border" /></p>}
                </div>
              </>)}
            </Tab.Content>
          </Tab.Container>
        </>
      )}
    </>
  );
};

const NovaAgenda =({data, queryParams, setAppointments})=>{
  const [query, setQuery] = useState('');
  const { metodo, tipo:t2, id:id2 } = useParams();
  const [tipo, setTipo] = useState(t2);
  const [contatos, setContatos] = useState([]);
  const [contatosSelecionados, setContatosSelecionados] = useState([]);
  const [checkinsSelecionados, setCheckinsSelecionados] = useState([]);
  const [agenda, setAgenda] = useState(null);
  const [maisTipo, setMaisTipo] = useState(false);
  const [fileFoto, setFileFoto] = useState(null);
  const [isLead, setIsLead] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [tableSelected, setTableSelected] = useState(null)
  const navigate = useNavigate();
  const { 
    setLinks, 
    setBtns,
    crud,
    hasPerms,
  } = useProvider();
  const { get, post, del, patch, loading } = crud || {};
  const id = queryParams.get('i')?.toLowerCase() || id2;
  
  useEffect(()=>{
    const buscarIdAgenda = async()=>{
      try{
        const response = await get(`/gvendas/agendas/${id}/?expand=clientes,leads,contato,checkins`,'agenda');
        if(response && response.length){
          setAgenda(response[0]);
          setIsLead(response[0].leads.length>0);
          setCheckinsSelecionados(response[0].checkins);
          setContatosSelecionados([
            ...response[0].clientes,
            ...response[0].leads.map(x => x.contato)
          ]);
        }
      }catch(err){
        
      }
    }
    if(id){
      buscarIdAgenda();
    }
  },[id])
  
  useEffect(() => {
      setLinks([
          // { name: 'Nova Venda', to: '/vendas/novo' },
          // { name: 'Novo Produto', to: '/produtos/novo' },
          // { name: 'Novo Cliente', to: '/clientes/novo' },
          //{ name: 'Configurações', to: '/configuracoes' },
      ]);
      setBtns([
          ...(id?[
              {icon:'bi-trash', onClick:() => {excluirAgenda()}},
            ]:[])
          //{icon:'bi-pencil-square', to:`/clientes/${id}/editar`},
      ]);
      return () => {setLinks([]); setBtns([]);}
  }, [setLinks, setBtns, loading]);
  
  useEffect(()=>{
    setAgenda((prevItem) => ({
      ...prevItem,
      data: data?.format("YYYY-MM-DDTHH:mm")
    }))
  },[data])
  
  useEffect(()=>{
    if(query){
      pesquisar();
    }else{
      setContatos([]);
    }
  }, [query])
  
  const pesquisar = async()=>{
    let url=`/gvendas/clientes/?expand=regiao&ordering=-nome_do_cliente&filtros=id,nome_do_cliente,full_name,nome,telefone`;
    if (query) url += `&search=${query}`;
    try{
      const response = await get(url,'query');
      if(response && response.length){
        setContatos(response[0].results);
      }
    }catch(err){
      
    }
  }
  
  const adicionarContato = async () =>{
    try{
      const response = await post({
        'nome_do_cliente':query
      },`/gvendas/clientes/`);
      if (response && response.length){
        addOrRemoveSelecao(response[0]);
        setQuery('');
      }
    }catch(err){
      
    }
  }
  
  const salvarAgenda = async () =>{
    try{
      //alert(JSON.stringify(agenda))
      delete agenda.folder

      const apiRequest = agenda.id?patch:post;
      if (!agenda.id){
        agenda.metodo = metodo || tipo;
      }
      const response = await apiRequest(
        agenda,
        `/gvendas/agendas/${agenda.id?agenda.id+'/':''}`, 
      );
      if(response && response.length){
        //alert(JSON.stringify(response[0]))
        setAgenda(response[0]);
        navigate(-1);
      }
    }catch(err){
      
      //alert(JSON.stringify(err.response))
    }
  }
  
  const excluirAgenda = async () => {
    try {
      await del(`/gvendas/agendas/${id}/`);
      setAppointments(prev => prev.filter(item => item.id !== id));
    } catch (err) {
      console.error('Erro ao excluir agenda:', err);
    }
  };
  
  const addOrRemoveSelecao = (item) =>{
    setContatosSelecionados((prevItem) => {
      const itemExists = prevItem.some(x => x.id === item.id);
      if (itemExists) {
        return prevItem.filter(x => x.id !== item.id);
      } else {
        return [...prevItem, item];
      }
    });
  }
  const addOrRemoveCheckins = (item) =>{
    setCheckinsSelecionados((prevItem) => {
      const itemExists = prevItem.some(x => x.id === item.id);
      if (itemExists) {
        return prevItem.filter(x => x.id !== item.id);
      } else {
        return [...prevItem, item];
      }
    });
  }
  
  useEffect(()=>{
    const enviarFolder = async()=>{
      try{
        const formData = new FormData();
        if (fileFoto) formData.append('folder', fileFoto);
        const response = await patch(formData,`/gvendas/agendas/${agenda?.id}/`, `multipart/form-data`);
        if(response && response.length){
          //alert(response[0].folder)
          setFileFoto(null);
        }
      }catch(err){
        //alert(JSON.stringify(err.response))
      }
    }
    if(agenda?.id && fileFoto){
      enviarFolder();
    }
  },[agenda?.folder])
  
  useEffect(()=>{
    const idsSelecionados = new Set(contatosSelecionados.map(y => y.id));
    setCheckinsSelecionados(checkinsSelecionados.filter(x => idsSelecionados.has(x.id)));
  },[contatosSelecionados])
  
  useEffect(() => {
    setAgenda((prevItem) => ({
      ...prevItem,
      [!isLead ? 'leads' : 'clientes']: [],
      [isLead ? 'leads' : 'clientes']: contatosSelecionados.map(contato => isLead?contato.contato_lead:contato.id),
      'checkins': checkinsSelecionados.map(contato => contato.id),
    }));
  }, [contatosSelecionados, checkinsSelecionados, isLead]);

  return (
    <>
      {(metodo === "evento" || tipo === "evento") && <ImageCropper foto={agenda?.folder} setFoto={setFileFoto} radius={3} width={800} height={600} className="col-8 col-md-5 mx-auto"/>}
      <Form.Group controlId="formTitulo" className="my-2">
        <InputGroup>
          <span className="input-group-text">Título</span>
          <Form.Control 
            type="text" 
            className="form-control-lg"
            value={agenda?.titulo} 
            onChange={(e) => 
              setAgenda((prevItem) => ({
                ...prevItem,
                titulo: e.target.value
              }))
            }
          />
        </InputGroup>
        {formErrors.titulo && <Alert variant="danger">{formErrors.titulo}</Alert>}
      </Form.Group>
      {(!metodo && !agenda?.id) && (
        <Form.Group controlId="formTipo" className="mt-3">
          <div className="input-group">
            <span className="input-group-text">Tipo</span>
            <Form.Control 
              as="select" 
              value={tipo} 
              onChange={(e) => setTipo(e.target.value)}
            >
              <option value=""></option>
              <option value="visita">Visita</option>
              <option value="evento">Evento</option>
              {hasPerms(['leads']) && <option value="apn">Apresentação de negócio (APN)</option>}
            </Form.Control>
            {formErrors.tipo && <Alert variant="danger">{formErrors.tipo}</Alert>}
          </div>
        </Form.Group>
      )}
      <Form.Group controlId="formData" className="my-2">
        <InputGroup>
          <span className="input-group-text">Data</span>
          <Form.Control 
            type="date" 
            value={agenda?.data?.split('T')[0]} 
            onChange={(e) => 
              setAgenda((prevItem) => ({
                ...prevItem,
                data: `${e.target.value}T${prevItem?.data?.split('T')[1]||'00:00'}`
              }))
            }
          />
          <span className="input-group-text">Hora</span>
          <Form.Control 
            type="time" 
            value={agenda?.data?.split('T')[1]?.slice(0, 5)||'00:00'} 
            onChange={(e) => 
              setAgenda((prevItem) => ({
                ...prevItem,
                data: `${prevItem?.data?.split('T')[0]}T${e.target.value||'00:00'}`
              }))
            }
          />
        </InputGroup>
        {formErrors.data && <Alert variant="danger">{formErrors.data}</Alert>}
      </Form.Group>
      <Form.Group controlId="formTipo" className="my-2 d-none">
        <InputGroup>
          <span className="input-group-text">Tipo</span>
          <Form.Control 
            type="text" 
            value={agenda?.categoriaagenda?.nome_da_categoria} 
            onChange={(e) => 
              setAgenda((prevItem) => ({
                ...prevItem,
                nome_da_categoria: e.target.value
              }))
            }
          />
          <Button variant="secondary" onClick={()=>setMaisTipo(!maisTipo)}>
            {maisTipo?(<>
              <i className="bx bx-up-arrow"></i>
            </>):(<>
              <i className="bx bx-down-arrow"></i>
            </>)}
          </Button>
        </InputGroup>
        {formErrors.categoriaagenda && <Alert variant="danger">{formErrors.categoriaagenda}</Alert>}
      </Form.Group>
      <Form.Group controlId="formBasicSearch" className="my-2">
        <div className="input-group">
            <span className="input-group-text">{isLead?"Lead":"Contato"}</span>
              <Form.Control 
                type="text" 
                placeholder={`Pesquisar ${isLead?"lead":"contato"} pelo nome`} 
                value={query} 
                onChange={(e) => setQuery(e.target.value)} 
              />
              <Button variant="secondary" onClick={() => pesquisar()}>
                <i className="bi bi-search"></i>
              </Button>
            </div>
      </Form.Group>
      {(hasPerms(['leads']) && (tipo === "apn" || metodo === "apn")) && (
        <>
          <Form.Group controlId="formIsLead" className="my-2">
            <Form.Check 
              type="switch" 
              label="Agenda para Lead"
              checked={isLead} 
              onChange={(e) => setIsLead(!isLead)}
            />
            {formErrors.lead && <Alert variant="danger">{formErrors.lead}</Alert>}
          </Form.Group>
        </>
      )}
      {contatos.length > 0 && (
        <>
          <div className="table-responsive">
            <Table className="table-bordered">
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Nome do {isLead?"Lead":"Contato"}</th>
                  <th>Telefone</th>
                  <th>Local</th>
                </tr>
              </thead>
              <tbody>
                {contatos.map(item => (
                  <tr onClick={()=>addOrRemoveSelecao(item)} className={contatosSelecionados.some(x => x.id === item.id)?'table-light':''}>
                    <td>
                      <Form.Check 
                        type="switch" 
                        checked={contatosSelecionados.some(x => x.id === item.id)} 
                      />
                    </td>
                    <td>{item.full_name || item.nome_do_cliente}</td>
                    <td>{item.telefone}</td>
                    <td>{item.regiao?.nome}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div className="text-center">
            <Button variant="outline-secondary" className="px-5 mb-3 btn-sm" onClick={()=>setQuery('')}>Concluir seleção</Button>
          </div>
        </>
      )}
      {(query && contatos.length === 0 && !loading) && (
        <>
          <div className="text-center text-muted">
            Nenhum contato encontrato
          </div>
          <div className="text-center">
            <Button variant="secondary" onClick={adicionarContato} className="px-5">Adicionar contato</Button>
          </div>
        </>
      )}
      {(contatosSelecionados.length > 0 && contatos.length===0) && (
        <div className="table-responsive">
          <Table className="table-bordered">
            <thead className="table-dark">
              <tr>
                <th>{isLead?"Lead":"Contato"}{` selecionado${contatosSelecionados.length>1?'s':''}`}</th>
                <th>Telefone</th>
                <th>Ok</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {contatosSelecionados.map(item => (
                <tr className={checkinsSelecionados.some(x => x.id === item.id)?'table-info':''}>
                  <td>{item.full_name || item.nome_do_cliente}</td>
                  <td>{item.telefone}</td>
                  <td>
                    <Form.Check 
                      type="switch" 
                      checked={checkinsSelecionados.some(x => x.id === item.id)} 
                      onChange={()=>addOrRemoveCheckins(item)}
                    />
                  </td>
                  <td><Button onClick={()=>addOrRemoveSelecao(item)} variant="danger" className="btn-sm"><i className="bi bi-trash"></i></Button></td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
      <Form.Group controlId="formObservacoes" className="my-2">
        <Form.Control
          as="textarea"
          placeholder="Observações"
          rows={3}
          value={agenda?.observacoes}
          onChange={(e) => setAgenda((prevItem)=>({
            ...prevItem,
            observacoes:e.target.value
          }))}
        />
      </Form.Group>
      {parseInt(id||0)>0 && (
        <>
          <Form.Group controlId="formIsRealizado" className="my-2">
            <Form.Check 
              type="switch" 
              label="Realizado"
              checked={agenda?.is_realizado} 
              onChange={(e) => setAgenda((prevItem)=>({
                ...prevItem,
                is_realizado:e.target.checked,
                is_cancelado:e.target.checked?false:prevItem.is_cancelado
              }))}
            />
            {formErrors.is_realizado && <Alert variant="danger">{formErrors.is_realizado}</Alert>}
          </Form.Group>
          <Form.Group controlId="formIsCancelado" className="my-2">
            <Form.Check 
              type="switch" 
              label="Cancelado"
              checked={agenda?.is_cancelado} 
              onChange={(e) => setAgenda((prevItem)=>({
                ...prevItem,
                is_cancelado:e.target.checked,
                is_realizado:e.target.checked?false:prevItem.is_realizado
              }))}
            />
            {formErrors.is_realizado && <Alert variant="danger">{formErrors.is_realizado}</Alert>}
          </Form.Group>
        </>
      )}
      <div className="text-center">
          <Button
            variant="secondary"
            className="mb-5 mt-3 w-100"
            onClick={salvarAgenda}
          >
            Salvar
          </Button>
      </div>
    </>
  )
}

export default Calendar;